import * as Sentry from "@sentry/react";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Utility function to manually capture errors in Sentry
 * Useful for testing or capturing non-thrown errors
 */
export function captureError(error: Error, context?: Record<string, any>) {
  if (context) {
    Sentry.setContext("error_context", context);
  }
  Sentry.captureException(error);
}

/**
 * Utility function to capture messages in Sentry
 * Useful for tracking important events or warnings
 */
export function captureMessage(message: string, level: Sentry.SeverityLevel = "info", context?: Record<string, any>) {
  if (context) {
    Sentry.setContext("message_context", context);
  }
  Sentry.captureMessage(message, level);
}
